/**
 * SFrame208 — Determine final personal income tax (checklist-only).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-208';

const ITEMS = [
  {
    id: 'i8-1',
    title: 'Verify Last Filed Return',
    description: "Locate and review the decedent's most recently filed federal income tax return.",
  },
  {
    id: 'i8-2',
    title: 'Identify Income Sources for Final Year',
    description: 'Gather all W-2s, 1099s, and other income documents for the final partial tax year.',
  },
  {
    id: 'i8-3',
    title: 'Determine Filing Status',
    description:
      'Confirm whether to file as Single, Married Filing Jointly (with surviving spouse), or Qualifying Widow(er).',
  },
];

export default function SFrame208() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Determine Final Personal Income Tax"
      backTo={`/sframe-207/${estateId}`}
      backLabel="← Tax Filings"
      items={ITEMS}
      syncTaxDt4Guided
    />
  );
}
